export const tourStepKey = 'tourStepId';
export const tourKeyParam = 'tourKey';

export const TOOLTIP_DEFAULT_SKIDDING = 32;
export const TOOLTIP_SCREEN_PADDING = 16;
